var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6032 0.183267L2.70372 0.183267C2.16689 0.18453 1.67151 0.472091 1.40419 0.93763C1.13687 1.40317 1.13822 1.97596 1.40773 2.44023C1.67724 2.90451 2.17396 3.18973 2.71079 3.18847L8.96868 3.1814L0.900593 11.2495C0.314807 11.8353 0.314807 12.785 0.900594 13.3708C1.48638 13.9566 2.43613 13.9566 3.02191 13.3708L11.09 5.30272L11.0829 11.5606C11.0833 12.1669 11.4486 12.7133 12.0087 12.9454C12.5688 13.1775 13.2136 13.0496 13.6427 12.6213C13.9231 12.3324 14.0737 11.9418 14.0599 11.5394L14.0599 1.63991C14.0593 0.812208 13.3885 0.141355 12.5608 0.140841L12.6032 0.183267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dc027e5a80c4a66f7867d3f4a16d8d85.svg";
export { ForwardRef as ReactComponent };